import React, { useState } from 'react'
import { useTheme } from 'react-jss'
import { Root, Portal, Overlay, Content } from '@radix-ui/react-dialog'
import { useStyles } from '../../../ui/Dialog/Dialog'
import { IkonFjernreminder, IkonSammenlaeg } from '../../../../assets/icons'
import { L } from '../../../providers/Lokalise'
import { colors } from '../../../../theme/palette'
import { Button } from '../../../ui/Button/Button'
import { deleteReminder } from '../../../../api/salary'
import Title from '../../../ui/Dialog/Title'
import { useErrorDialog } from '../../../../hooks/useErrorDialog'
import { ErrorDisplay } from '../Contact/ContactDialog'

interface RemoveReminderProps {
    onSuccess: () => void
    onCancel?: () => void
    caseRegistrationDate: string
    caseId: string
    reminderId: string
}

const RemoveReminder: React.FC<RemoveReminderProps> = ({
    onSuccess,
    onCancel,
    caseRegistrationDate,
    caseId,
    reminderId,
}): JSX.Element => {
    const iconBGColor = colors.redLight100
    const iconBorder = colors.white
    const theme = useTheme<Jss.Theme>()
    const [isLoading, setIsLoading] = useState(false)
    const { showError, ErrorDialogComponent } = useErrorDialog() as any

    const classes = useStyles({
        ...{ iconBGColor, iconBorder },
        theme,
    })
    const handleDeleteReminder = async (): Promise<void> => {
        setIsLoading(true)
        const response = await deleteReminder({
            caseId: String(caseId),
            caseRegTime: String(caseRegistrationDate),
            reminderId: String(reminderId),
        })

        if (response.error) {
            showError(<ErrorDisplay errors={response.error.errors} />)
            setIsLoading(false)
            return
        }

        if (response) {
            onSuccess()
        }
        setIsLoading(false)
    }
    return (
        <>
            <Root defaultOpen>
                <Portal>
                    <Overlay className={classes.overlay} />
                    <Content className={`${classes.overlayContainer}`}>
                        <div className={`${classes.container} withIcon`}>
                            <div className={`${classes.circleIcon} withIcon`}>
                                <IkonFjernreminder
                                    width="46px"
                                    fill={colors.red500}
                                />
                            </div>
                            <Title
                                title={L('LØN_FJERN_REMINDER_DIALOG_TITEL')}
                                style={{ marginBottom: '30px' }}
                            />
                            <div style={{ display: 'flex', gap: '1rem' }}>
                                <Button
                                    type="secondary"
                                    size="xlarge"
                                    onClick={onCancel}
                                >
                                    {L(
                                        'LØN_FJERN_REMINDER_DIALOG_FORTRYD_KNAP'
                                    )}
                                </Button>
                                <Button
                                    type="danger"
                                    size="xlarge"
                                    onClick={handleDeleteReminder}
                                    loading={isLoading}
                                >
                                    {L('LØN_FJERN_REMINDER_DIALOG_FJERN_KNAP')}
                                </Button>
                            </div>
                        </div>
                    </Content>
                </Portal>
            </Root>
            <ErrorDialogComponent />
        </>
    )
}

export default RemoveReminder
